<template>
  <EditFormDialog
    :formData="formData"
    :rules="rules"
    :formType="'update'"
    :loading="loading"
    :labelWidth="'200px'"
    :formVisible="formVisible"
    @submitForm="submitForm"
    v-bind="$attrs"
    v-on="$listeners"
  >

    <el-form-item :label="$t('jie-kou-ming-cheng')" prop="interfaceName">
      <el-input
        size="small"
        v-model="formData.interfaceName"
        style="width: 80%" maxlength="50" show-word-limit
        :placeholder="$t('qing-shu-ru-0')"></el-input>
    </el-form-item>


    <el-form-item :label="$t('jie-kou-miao-shu')" prop="interfaceExplain">
      <el-input
        type="textarea" :rows="3"
        v-model="formData.interfaceExplain"
        style="width: 80%" maxlength="50" show-word-limit
        :placeholder="$t('qing-shu-ru-0')"></el-input>
    </el-form-item>


  </EditFormDialog>
</template>
<script>
    import api from '@/module/interactionCenter/api/interface.js'
    import EditFormDialog from '@/components/EditFormDialog'
    import {validateInput} from "../../../../../common/validator";

    export default {
        props: {
            searchData: {
                type: Object,
                required: true
            },
            selectRowData: {
                type: Object,
                required: true
            },
            formVisible: {
                type: Boolean,
                required: true
            }
        },
        components: {
            EditFormDialog
        },
        data() {
            return {
                loading: false, // 是显示加载
                dialogVisible: false,
                // 表单
                formData: {
                    id: '',
                    interfaceName: '',
                    interfaceExplain: ''
                },
                // rules表单验证
                rules: {
                    interfaceName: [{required: true, message: this.$t('qing-shu-ru-jie-kou-ming-cheng'), trigger: 'blur'},
                        {max: 50, message: this.$t('jie-kou-ming-cheng-bu-neng-chao-guo-50-wei'), trigger: 'blur'},
                      {
                        validator: function (rule, value, callback) {
                          validateInput(rule, value, callback, 0, 50, true, false, true, false, false, false, false)
                        },required: true, trigger: 'blur'
                      }],
                    interfaceExplain: [{required: true, message: this.$t('qing-shu-ru-jie-kou-jie-shi'), trigger: 'blur'},
                        {max: 50, message: this.$t('jie-kou-jie-shi-bu-neng-chao-guo-50-wei'), trigger: 'blur'}]
                }

            }
        },
        created() {
        },
        computed: {},
        watch: {
            formVisible: {
                handler: 'getData',
                immediate: true
            },
        },
        methods: {
            getData() {
                if (this.formVisible && this.selectRowData && this.selectRowData.id) {
                    this.loading = true
                    api.getInterfaceById(this.selectRowData.id).then(res => {
                        this.loading = false
                        if (res.code === 0) {
                            this.formData = res.data
                        } else {
                            this.$message.error(res.message)
                        }
                    })
                }
            },
            // 编辑、添加提交方法
            submitForm() {
                this.loading = true
                api.update(this.formData).then((res) => {
                    if (res.code === 0) {
                        this.$message({
                            type: 'success',
                            message: this.$t('bian-ji-cheng-gong')
                        })
                        this.$emit('afterUpdate')
                    } else {
                        this.$message.error(res.message)
                    }
                }).finally(()=>{
                    this.loading = false
                })
            },
        }
    }
</script>

<style lang="less" scoped>

</style>



// WEBPACK FOOTER //
// src/module/interactionCenter/page/cec/interface/update.vue